module.exports = __webpack_public_path__ + "img/success.46a3e30b.png";